module.exports = __webpack_public_path__ + "static/media/mesAvatar4.f5e37525.jpg";